import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "pt-3 pb-2 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, " Notificações ")
], -1)
const _hoisted_2 = { class: "row row-cols-1 row-cols-md-3 row-cols-md-4 g-2" }
const _hoisted_3 = { class: "col-sm-3 col-xl-3 mb-3" }
const _hoisted_4 = {
  class: "card",
  style: {"width":"18rem"}
}
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "col-sm-3 col-xl-3 mb-3" }
const _hoisted_10 = {
  class: "card",
  style: {"width":"18rem"}
}
const _hoisted_11 = { class: "card-header" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = {
  key: 0,
  class: "pt-3 pb-2"
}
const _hoisted_16 = { class: "pt-3 pb-2 mb-3" }
const _hoisted_17 = { class: "table-responsive mb-4" }
const _hoisted_18 = { class: "table table-striped table-sm" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Ações "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " # "),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Descrição"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Tag"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, " Situação")
  ])
], -1)
const _hoisted_20 = { class: "btn-group mr-2" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 1,
  class: "d-flex justify-content-center mt-4 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", null, [
                _createVNode(_component_font_awesome_icon, { icon: "users" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h1", _hoisted_8, _toDisplayString($setup.contSub), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", null, [
                _createVNode(_component_font_awesome_icon, { icon: "bell" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h1", _hoisted_14, _toDisplayString($setup.dados.totalreg), 1)
          ])
        ])
      ])
    ]),
    ($setup.acesso.btnInsert)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_router_link, {
            to: `/notificationcreate/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}/${$setup.route.params.siteid}`,
            class: "btn btn-sm btn-outline-secondary"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: "file" })
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("input", {
        class: "form-control",
        placeholder: "Procurar Nome ou Descrição",
        onKeyup: _cache[0] || (_cache[0] = ($event: any) => ($setup.search($event.target.value)))
      }, null, 32)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("table", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredTable, (noti) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: noti.id
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_20, [
                  ($setup.acesso.btnAlter)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: `/notificationedit/${$setup.route.params.t}/${$setup.route.params.id}/${$setup.route.params.perfil}/${noti.id}/${$setup.route.params.siteid}/edit`,
                        class: "btn btn-sm btn-outline-secondary",
                        title: "Alterar Notificação"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true),
                  ($setup.acesso.btnDelete)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        title: "Excluir Notificação",
                        onClick: ($event: any) => ($setup.del(noti.id))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "trash-alt" })
                      ], 8, _hoisted_21))
                    : _createCommentVNode("", true),
                  ($setup.acesso.btnDelete)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: "javascript:void(0)",
                        class: "btn btn-sm btn-outline-secondary",
                        title: "Enviar Notificação",
                        onClick: ($event: any) => ($setup.send(noti.id))
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: "paper-plane" })
                      ], 8, _hoisted_22))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(noti.id), 1),
              _createElementVNode("td", null, _toDisplayString(noti.descricao), 1),
              _createElementVNode("td", null, _toDisplayString(noti.tag), 1),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(noti.status==1 ? 'btn btn-success mr-2 mt-2' : 'btn btn-warning mr-2 mt-2')
                }, [
                  (noti.status==1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Enviado"))
                    : _createCommentVNode("", true),
                  (noti.status==0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, " Não Enviado"))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    ($setup.page < $setup.lastPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.loadMore && $setup.loadMore(...args)))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}